import { render } from "./UnAssignGroupCharges.vue?vue&type=template&id=6e9176b0"
import script from "./UnAssignGroupCharges.vue?vue&type=script&lang=js"
export * from "./UnAssignGroupCharges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__